module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(
    _vm.$route.path.indexOf('_detail') === -1 &&
    _vm.$route.path.indexOf('_edit') === -1
  ) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "商家编号",
      "size": "mini"
    },
    model: {
      value: (_vm.params.merchant_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "merchant_id", $$v)
      },
      expression: "params.merchant_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "资质证件类型ID",
      "size": "mini"
    },
    model: {
      value: (_vm.params.credential_type_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "credential_type_id", $$v)
      },
      expression: "params.credential_type_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.toAdd()
      }
    }
  }, [_vm._v("新增+")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.dataList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "merchant_id",
      "label": "商家编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "credential_type_id",
      "label": "资质证件类型ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "credential_url",
      "label": "资质证文件链接"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.credential_url,
            "alt": ""
          }
        })]
      }
    }], null, false, 632942418)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "credential_expire",
      "label": "有效期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          },
          on: {
            "click": function($event) {
              return _vm.del(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2310518291)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pagesize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增*编辑",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商家编号",
      "prop": "merchant_id"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.merchant_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchant_id", $$v)
      },
      expression: "form.merchant_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资质证件类型ID",
      "prop": "credential_type_id"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.credential_type_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "credential_type_id", $$v)
      },
      expression: "form.credential_type_id"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资质证文件链接",
      "prop": "credential_url"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('credential_url')
      }
    }
  }, [(_vm.form.credential_url) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.credential_url
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("\n              资质证文件链接|只能上传jpg/png文件，且不超过2M\n            ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期",
      "prop": "credential_expire"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-DD",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.credential_expire),
      callback: function($$v) {
        _vm.$set(_vm.form, "credential_expire", $$v)
      },
      expression: "form.credential_expire"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c7383d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c7383d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/merchant/credentials/list.vue
// module id = 2749
// module chunks = 0